import { render, staticRenderFns } from "./PesquisaProtesto.vue?vue&type=template&id=38dcbd52&scoped=true"
import script from "./PesquisaProtesto.vue?vue&type=script&lang=js"
export * from "./PesquisaProtesto.vue?vue&type=script&lang=js"
import style0 from "./PesquisaProtesto.vue?vue&type=style&index=0&id=38dcbd52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dcbd52",
  null
  
)

export default component.exports